export default {
    data: function () {
        return {
            preUploadFiles: [],
            uploadColumn: "",
            uploadLoading: false,
            uploads: [],
            uploadUrl: process.env.VUE_APP_UPLOAD,
            uploadHeaders: {
                "AUTH-ADMIN": localStorage.getItem("AUTH-ADMIN")
            },
            tempUploadFiles: [],
            // tempUploadFilesEx: [],
            successCount: 0,
            fileOrderMap: {}, // 存【uid => 上传顺序】
        }
    },
    methods: {
        uploadClick: function (column) {
            this.uploadColumn = column;
            this.preUploadFiles = this.uploads.find(item => item.column === this.uploadColumn).files;
            console.log("uploadClick");
            console.log(this.preUploadFiles);
        },
        uploadBefore: function (file) {
            this.fileOrderMap[file.uid] = Object.keys(this.fileOrderMap).length;
            this.tempUploadFiles.push(file);
            this.uploadLoading = true;
            console.log("uploadBefore");
            console.log(this.tempUploadFiles)
            return true;
        },
        uploadSuccessSingle: function (res) {
            this.uploadLoading = false;
            for (let i = 0; i < this.uploads.length; i++) {
                if (this.uploads[i].column == res.columnName) {
                    if (this.uploads[i].files.length == 0) {
                        this.uploads[i].files.push(res.fileName);
                    }
                    else {
                        this.uploads[i].files[0] = res.fileName;
                    }
                }
            }
            this.$forceUpdate();
        },
        uploadSuccessMulti: function (res, file) {
            this.successCount++;
            // 1. 找到当前上传列
            const target = this.uploads.find(item => item.column === res.columnName);
            
            console.log("uploadSuccessMulti");
            console.log(target);

            if (!target) return;
            // 2. 把成功的文件放进去
            if (!target.sources) target.sources = [];
            target.sources.push(file);
            // 3. 按上传前打的序号排序 → 顺序永远正确
            target.files = target.sources
                .sort((a, b) => this.fileOrderMap[a.uid] - this.fileOrderMap[b.uid])
                .map(item => item.response.fileName);
            // 4. 全部上传完成（写在循环外面！永不卡死）
            if (this.successCount === this.tempUploadFiles.length) {
                this.successCount = 0;
                this.tempUploadFiles = [];
                target.sources = [];
                this.uploadLoading = false;
                target.files = this.preUploadFiles.concat(target.files);
                this.preUploadFiles = [];
            }
            if (this.afterUpload) {
                this.afterUpload(res);
            }
        },
        // uploadSuccessMulti: function (res, file) {
        //     this.successCount++;
        //     for (let i = 0; i < this.uploads.length; i++) {
        //         let preFiles = this.uploads[i].files;
        //         console.log("preFiles");
        //         console.log(preFiles);
        //         this.uploads[i].files = [];
        //         if (!this.uploads[i].sources) {
        //             this.uploads[i].sources = [];
        //         }
        //         if (this.uploads[i].column == res.columnName) {
        //             this.uploads[i].sources.push(file);
        //             for (let j = 0; j < this.tempUploadFiles.length; j++) {
        //                 for (let k = 0; k < this.uploads[i].sources.length; k++) {
        //                     if (this.tempUploadFiles[j].uid == this.uploads[i].sources[k].uid) {
        //                         this.uploads[i].files.push(this.uploads[i].sources[k].response.fileName);
        //                         this.tempUploadFilesEx.push(this.uploads[i].sources[k].response.fileName);
        //                         break;
        //                     }
        //                 }
        //             }
        //         }
        //         if (preFiles) {
        //             for (let j = preFiles.length - 1; j >= 0; j--) {
        //                 let isExist = false;
        //                 for (let k = 0; k < this.tempUploadFilesEx.length; k++) {
        //                     if (preFiles[j] == this.tempUploadFilesEx[k]) {
        //                         isExist = true;
        //                         break;
        //                     }
        //                 }
        //                 if (!isExist) {
        //                     this.uploads[i].files.unshift(preFiles[j]);
        //                 }
        //             }
        //         }
        //         if (this.tempUploadFiles.length == this.successCount) {
        //             this.successCount = 0;
        //             this.tempUploadFiles = [];
        //             this.tempUploadFilesEx = [];
        //             this.uploads[i].sources = [];
        //             this.uploadLoading = false;
        //         }
        //     }
        //     if (this.afterUpload) {
        //         this.afterUpload(res);
        //     }
        // },
        beforeHandleUpload: function () {
            if (this.handle == "insert") {
                for (let i = 0; i < this.uploads.length; i++) {
                    this.uploads[i].files = [];
                }
            }
            else if (this.handle == "update" || this.handle == "detail") {
                for (let i = 0; i < this.uploads.length; i++) {
                    if (this.handleInfo[this.uploads[i].column]) {
                        this.uploads[i].files = this.handleInfo[this.uploads[i].column].split(",");
                    }
                }
            }
        },
        beforeHandleSubmit: function () {
            for (let i = 0; i < this.uploads.length; i++) {
                this.handleInfo[this.uploads[i].column] = this.uploads[i].files.join(",");
            }
        },
        afterHandleSubmit: function () {
            for (let i = 0; i < this.uploads.length; i++) {
                this.uploads[i].files = [];
            }
        },
        uploadRemove: function (column, index) {
            for (let i = 0; i < this.uploads.length; i++) {
                if (this.uploads[i].column == column) {
                    this.uploads[i].files.splice(index, 1);
                }
            }
        },
        getFiles: function (column) {
            var files = [];
            for (let i = 0; i < this.uploads.length; i++) {
                if (this.uploads[i].column == column) {
                    files = this.uploads[i].files;
                }
            }
            return files;
        },
        getFilesByStr: function (str) {
            var files = [];
            if (str) {
                let arr = str.split(",");
                for (let i = 0; i < arr.length; i++) {
                    files.push(arr[i]);
                }
            }
            return files;
        },
        uploadFirst: function (column, index) {  //设为封面
            for (let i = 0; i < this.uploads.length; i++) {
                if (this.uploads[i].column == column) {
                    let firstArr = this.uploads[i].files.splice(index, 1);
                    this.uploads[i].files.unshift(firstArr[0]);
                }
            }
        }
    }
}